<style/styles: any>
  .button {
    box-shadow: 4px 4px 1px 0px var(--dark);
    transition: all 100ms ease;
  }

  .button:hover {
    background-color: var(--primary-400);
  }

  .button:active {
    transform: translate(4px, 4px);
    box-shadow: none;
  }

  .buttonSecondary:hover {
    background-color: var(--secondary-600);
  }
</style>

export interface Input extends Marko.HTML.Button {
  outline?: boolean;
}

<const/{ class: className, outline, ...attrs }=input>
<button
  class=[
    "pi1 pb-5 radius1 border-solid border1 bg-accent text-light inline-block border-transparent flex justify-content-center align-items-center",
    styles.button,
    outline && "bg-light text-dark",
    outline && styles.buttonSecondary,
    className,
  ]
  ...attrs
/>
